<template lang="html">
  <div
    class="navigation"
    :class="{
      'backward': !hasBeenPushed,
      'forward': hasBeenPushed
    }"
  >
    <div class="toolbar bg-blue-400 color-white">
      <button
        class="icon-button"
        :class="{
          'hide': states.length <= 1
        }"
        @click="previous()"
      >
        <i class="icon-arrow-back"></i>
      </button>
      <span class="toolbar-label">Yaniv Scores</span>
      <span
        class="float-right"
        v-if="rightIcon && rightAction"
      >
        <button
          class="icon-button"
          @click="rightAction()"
        >
          <i :class="rightIcon"></i>
        </button>
      </span>
    </div>
    <transition name="view-transition">
      <component
        :is="state"
        class="view"
        key="state"
        @onPushState="onPushState"
        @onPopState="onPopState"
      >
      </component>
    </transition>
  </div>
</template>

<script>
import Navigation from '../view/navigation/Navigation.vue'
import PlayerList from './PlayerList.vue'
import Game from './Game.vue'
import GameList from './GameList.vue'
import EditScore from './EditScore.vue'

export default {
  mixins:[Navigation],
  components: {
    'game-list': GameList,
    'player-list': PlayerList,
    'game': Game,
    'edit-score': EditScore
  },
  data() {
    return {
      rightIcon: null,
      rightAction: () => {}
    }
  },
  mounted() {
    this.onPushState('game-list')
  },
  watch: {
    state() {
      this.$nextTick(() => {
        const header = this.$children[0] ? this.$children[0].$data.header || {} : {}
        this.rightIcon = header.rightIcon
        this.rightAction = header.rightAction
      })
      
    }
  },
}
</script>

<style lang="stylus">
@import '../styles/common'
.hide
  visibility hidden
  width 0

h1
  color white
  text-align center
  margin 0
  line-height header-height
  background-color #191919

.toolbar
  position relative
  z-index 1

.view
  position absolute
  top header-height
  left 0
  width 100%
  height 'calc(100% - %s)' % header-height
  overflow auto
  transform translate3d(0,0,0)
  transition transform 0.5s

.view-transition-enter,
.backward .view-transition-leave-active
  transform translate3d(100%,0,0)

.view-transition-enter-active {}
.view-transition-leave {}

.view-transition-leave-active,
.backward .view-transition-enter
  transform translate3d(-100%,0,0)
</style>



// WEBPACK FOOTER //
// MainNav.vue?0849f478